import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap-v5'
import axios from 'axios'
//const type = parse(history.location.search).type as stri
import {
  setCompanyVerificationMethod,
  setEntityData,
  setOpenVerification,
  setSubStep,
} from './redux/actions'

import { CompanyProfile } from '../../../svg/CompanyProfileIcon'
import { BankIcon } from '../../../svg/BankIIcon'
import { getIntegrationURLFromENV } from '../../../utils/getIntegrationURLFromENV'
import { parse } from 'query-string'
interface Props {
  show: boolean
  handleClose: any
  goToStep: any
}

const CompanyVerification: FC<Props> = ({
  show,
  handleClose,
  goToStep,
}: // goToStep
any) => {
  const dispatch = useDispatch()
  const history: any = useHistory()
  const loanApplicationId = localStorage.getItem('loanApplicationId')
  const agentCode = localStorage.getItem('agentCode')
  const [agentName, setAgentName] = useState<string>('')
  const [agentPhoneNumber, setAgentPhoneNumber] = useState<string>('')
  const [companyConfirmation, setCompanyConfirmation] = useState<string>('')
  const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false)
  const [showMyInfoCard, setShowMyInfoCard] = useState<boolean>(false)
  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const companyVerificationMethod = useSelector(
    (state: any) => state.loan.companyVerificationMethod
  )

  const searchQuery: any = parse(history.location.search)
  const getPartnerDetails = async (agentCode: string) => {
    const env = localStorage.getItem('env')
    const API_URL = getIntegrationURLFromENV(searchQuery?.env || env)

    const agentData = await axios.get(`${API_URL}ext/api/user/${agentCode || ''}`)
    if (agentData.data?.data?.userDetail) {
      setAgentName(
        agentData.data?.data?.userDetail?.firstName +
          ' ' +
          agentData.data?.data?.userDetail?.lastName
      )
    }
    setAgentPhoneNumber(agentData.data?.data?.userDetail?.phoneNumber)
  }

  useEffect(() => {
    if (agentCode) {
      getPartnerDetails(agentCode)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const connectMyInfo = async () => {
    localStorage.setItem('loanApplicationId', loanApplication?.id)
    localStorage.setItem('singpass', 'myinfobiz')

    // const singPassUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://iris-dev.credilinq.ai/api/alexi-singpass';
    const singPassUrl = process.env.REACT_APP_SINGPASS_URL || 'http://localhost:3002'

    const getEnv = await axios.get(singPassUrl + '/getEnv').then((response) => response.data)

    const state = Math.floor(Math.random() * 100000)
    //todo change the redirect url to this page getEnv
    const { clientId, redirectUrl, attributes, purpose, authApiUrl } = getEnv
    const authoriseUrl: any = `${authApiUrl}?client_id=${clientId}&attributes=${attributes}&purpose=${purpose}&state=${encodeURIComponent(
      state
    )}&redirect_uri=${redirectUrl}`
    ;(window as any).location = authoriseUrl
  }

  const submitProfileVerification = async () => {
    if (!companyConfirmation) {
      return
    }

    if (companyConfirmation === 'no') {
      setShowErrorMessage(true)
      return
    }

    if (companyConfirmation === 'yes' && !showMyInfoCard) {
      setShowMyInfoCard(true)
      return
    }

    if (companyVerificationMethod === 1) {
      localStorage.setItem('companyVerificationMethod', companyVerificationMethod.toString())
      connectMyInfo()
    } else {
      dispatch(setSubStep(3))
      localStorage.setItem('companyVerificationMethod', companyVerificationMethod.toString())

      if (
        loanApplicationId &&
        ['stage', 'sandbox', 'dev'].includes(localStorage.getItem('env') as string)
      ) {
        ;(async () => {
          const response = await import(
            `../../../utils/custom/${loanApplication.companyUEN}/step3.json`
          )
          const eligibilityData: any = response.default
          if (eligibilityData) {
            dispatch(setEntityData(eligibilityData))
          }
        })()
        history.replace(`/co-applicant-kyb/${loanApplicationId}?subStep=3`)
      } else {
        history.replace(`/co-applicant-kyb/${loanApplicationId}?subStep=3`)
      }
    }
    dispatch(setOpenVerification(false))
  }

  return (
    <>
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        show={show}
        centered // Bootstrap's built-in class for centering modals
      >
        <div className='modal-content w-100 px-8'>
          <div className='d-flex flex-column align-items-center justify-content-center pt-6'>
            <CompanyProfile className='mb-4' />
            <h2 className='section-heading m-0 mt-4 mb-2'>Verify Company Profile</h2>
          </div>
          <div className='d-block mx-5 my-5'>
            {!showErrorMessage && !showMyInfoCard ? (
              <div className='d-flex align-items-center min-h-145px'>
                <div className='fv-row fv-plugins-icon-container w-100'>
                  <div className='row'>
                    <div className='col-lg-12 loan-application '>
                      <p className='mb-4'>Is this your company name? Please confirm:</p>
                      <p className='mb-5'>
                        <strong className='fs-4'>
                          {loanApplication.loanEligibility.companyName}
                        </strong>
                        <br />
                        <span className='text-muted'>UEN: {loanApplication.companyUEN}</span>
                      </p>

                      <div className='d-flex flex-column gap-3 mb-4'>
                        <label
                          className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center ${
                            companyConfirmation === 'yes' ? 'active border-primary' : ''
                          }`}
                          style={{ cursor: 'pointer' }}
                        >
                          <input
                            type='radio'
                            name='companyConfirmation'
                            value='yes'
                            checked={companyConfirmation === 'yes'}
                            onChange={(e) => {
                              setCompanyConfirmation(e.target.value)
                              setShowMyInfoCard(false)
                            }}
                            className='form-check-input me-3'
                            style={{ width: '20px', height: '20px' }}
                          />
                          <span className='fw-bold'>Yes, this is my company</span>
                        </label>

                        <label
                          className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center ${
                            companyConfirmation === 'no' ? 'active border-primary' : ''
                          }`}
                          style={{ cursor: 'pointer' }}
                        >
                          <input
                            type='radio'
                            name='companyConfirmation'
                            value='no'
                            checked={companyConfirmation === 'no'}
                            onChange={(e) => setCompanyConfirmation(e.target.value)}
                            className='form-check-input me-3'
                            style={{ width: '20px', height: '20px' }}
                          />
                          <span className='fw-bold'>No, this is not my company</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : showMyInfoCard && !showErrorMessage ? (
              <div className='d-flex align-items-center justify-content-center min-h-145px'>
                <div className='fv-row fv-plugins-icon-container w-100'>
                  <div className='row'>
                    <div className='col-lg-12 loan-application'>
                      <label className='btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center mb-3 verify-profile verify-profile-click'>
                        <BankIcon color='var(--primary-color)' />
                        <span className='d-block fw-bold text-start ms-4'>
                          <span className='text-primary fw-bold d-block fs-3 mb-0 font-secondary'>
                            MyInfo Business with SingPass
                          </span>
                          <span className='fw-light text-color-10 fs-6'>
                            Takes about 1-2 minutes
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className='d-flex align-items-center justify-content-center min-h-145px'>
                <div className='text-center'>
                  <p className='fs-5 mb-4'>
                    Thanks for confirming! Please reach out to{' '}
                    <strong>{agentName || 'Support Agent'}</strong>{' '}
                    {agentPhoneNumber && `at ${agentPhoneNumber} `}
                    to update your UEN.
                  </p>
                  <p className='text-dark'>
                    Share your{' '}
                    <strong className='fs-5 text-dark'>
                      Application Number: {loanApplication?.applicationNumber}{' '}
                    </strong>{' '}
                    and{' '}
                    <strong className='fs-5 text-dark'>
                      Company Name: {loanApplication?.loanEligibility?.companyName}
                    </strong>{' '}
                    for quick reference.
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className='d-flex flex-column gap-5 flex-center mx-5 my-10'>
            {!showErrorMessage && !showMyInfoCard ? (
              <>
                {companyConfirmation && (
                  <button
                    id={agentCode ? 'button-primary' : ''}
                    className='button button-primary w-100'
                    onClick={() => submitProfileVerification()}
                  >
                    Verify
                  </button>
                )}
                {!agentCode && (
                  <>
                    <div className='line d-flex justify-content-center text-muted'>
                      <span className='zIndex-1'>OR</span>
                    </div>
                    <button
                      className='button button-outline-back w-100'
                      onClick={() => {
                        dispatch(setSubStep(1))
                        dispatch(setCompanyVerificationMethod(1))
                        dispatch(setOpenVerification(false))
                      }}
                    >
                      Back
                    </button>
                  </>
                )}
              </>
            ) : showMyInfoCard && !showErrorMessage ? (
              <>
                <button
                  id={agentCode ? 'button-primary' : ''}
                  className='button button-primary w-100'
                  onClick={() => submitProfileVerification()}
                >
                  Verify
                </button>
                <button
                  className='button button-outline-back w-100'
                  onClick={() => {
                    setShowMyInfoCard(false)
                    setCompanyConfirmation('')
                  }}
                >
                  Back
                </button>
              </>
            ) : (
              <button
                className='button button-outline-back w-100'
                onClick={() => {
                  dispatch(setOpenVerification(false))
                  handleClose()
                }}
              >
                Close
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CompanyVerification
